<script setup lang="ts">
import { useI18n } from "vue-i18n";

/**
 * Undismissable by design.
 *
 * ADR-0005's amendment traded prevention for attribution and recorded the risk plainly: one
 * compromised platform_admin account can create money at any Casino and adjust what would show it.
 * This banner is that trade said out loud, at the moment it applies — which is the only place it is
 * worth saying. There is deliberately no close button.
 */
defineProps<{ casino: string }>();
defineEmits<{ leave: [] }>();
const { t } = useI18n();
</script>

<template>
  <div class="breakglass" role="status">
    <span class="ico" aria-hidden="true">⚿</span>
    <div class="body">
      <div class="title">{{ t("breakglass.acting", { casino }) }}</div>
      <div class="sub">{{ t("breakglass.recorded") }}</div>
    </div>
    <button class="action leave" @click="$emit('leave')">
      {{ t("breakglass.leave", { casino }) }}
    </button>
  </div>
</template>

<style scoped>
.ico {
  font-size: 17px;
  line-height: 1.3;
}
.body {
  flex: 1;
  min-width: 0;
}
.title {
  font-weight: 500;
  font-size: var(--fs-small);
}
.sub {
  font-size: var(--fs-small);
  opacity: 0.9;
}
.leave {
  height: auto;
  padding: 5px 11px;
  font-size: var(--fs-micro);
  border-color: currentColor;
  color: inherit;
}
</style>
